import { render, staticRenderFns } from "./case_presentation.vue?vue&type=template&id=9858d6f4&scoped=true"
import script from "./case_presentation.vue?vue&type=script&lang=js"
export * from "./case_presentation.vue?vue&type=script&lang=js"
import style0 from "./case_presentation.vue?vue&type=style&index=0&id=9858d6f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9858d6f4",
  null
  
)

export default component.exports